import * as React from "react";
import { forwardRef } from "react";
const SvgInfoChannels = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 20, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21 1H1L9 10.46V17L13 19V10.46L21 1Z", stroke: "black", strokeOpacity: 0.9, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgInfoChannels);
export default ForwardRef;
